export const quarters = [
  {
    label: "第一季度",
    value: 1,
    startTime: "01-01 00:00:00"
  },
  {
    label: "第二季度",
    value: 2,
    startTime: "04-01 00:00:00"
  },
  {
    label: "第三季度",
    value: 3,
    startTime: "07-01 00:00:00"
  },
  {
    label: "第四季度",
    value: 4,
    startTime: "10-01 00:00:00"
  }
]

export const halfYears = [
  {
    label: "上半年",
    value: 1,
    startTime: "01-01 00:00:00"
  },
  {
    label: "下半年",
    value: 2,
    startTime: "07-01 00:00:00"
  }
]
